<!-- TODO: the details can be displayed with the reuseable details container component:
LensDetailsContent.vue -->

<template>
  <section class="select-pdf-section">
    <div class="pdf-logo">
      <img :src="userStore.logoSourceBlack" alt="" />
    </div>

    <div>
      <img :src="`data:image/png;base64,${select.flareImageBase64 || baseImgUrl}`" />
    </div>

    <div class="pdf-head-data">
      <img src="@/assets/img/lens-icon.svg" width="30" alt="" />
      <div class="pdf-lens-head">
        {{ select.name }}
      </div>
      <div class="pdf-lens-head">
        {{ select.focalLength }}
      </div>
      <div class="pdf-lens-head">
        {{ select.transmission }}
      </div>
      <img
        :src="`data:image/png;base64,${select.iconBase64 || iconBase64}`"
        alt=""
        class="wishlist-lens-icon"
      />
      <span class="details-pill">{{ select.categoryName }}</span>
    </div>
    <div class="lens-pdf-heading">Lens Specifications</div>
    <div>
      <div class="details-container">
        <div class="details-top-row">
          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Focal Length:</div>
              <div class="detail-value">
                {{ select.focalLength ? select.focalLength : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head">Transmission:</div>
              <div class="detail-value">
                {{ select.transmission ? select.transmission : 'N/A' }}
              </div>
            </div>
          </div>
          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Manufacturer:</div>
              <div class="detail-value">
                {{ select.manufacturer ? select.manufacturer : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head cliphead">Series:</div>
              <div class="value-box-w-tooltip">
                <div class="clipped-tooltip" v-if="select.series">
                  {{ select.series }}
                </div>
                <div class="detail-value clip">
                  {{ select.series ? select.series : 'N/A' }}
                </div>
              </div>
            </div>
          </div>
          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Lens Type:</div>
              <div class="detail-value">
                {{ select.lensType ? select.lensType : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head">Lens Format:</div>
              <div class="detail-value">
                {{ select.lensFormat ? select.lensFormat : 'N/A' }}
              </div>
            </div>
          </div>
          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Image Circle:</div>
              <div class="detail-value">
                {{ select.imageCircle ? select.imageCircle : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head">Aperture Range:</div>
              <div class="detail-value">
                {{ select.apertureRange ? select.apertureRange : 'N/A' }}
              </div>
            </div>
          </div>
          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Distortion:</div>
              <div class="detail-value">
                {{ select.distortion ? select.distortion : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head">Weight:</div>
              <div class="detail-value">
                {{ select.weight ? select.weight : 'N/A' }}
              </div>
            </div>
          </div>
          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Squeeze Factor:</div>
              <div class="detail-value">
                {{ select.squeezeFactor ? select.squeezeFactor : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head">Mount:</div>
              <div class="detail-value">
                {{ select.mount ? select.mount : 'N/A' }}
              </div>
            </div>
          </div>

          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Year:</div>
              <div class="detail-value">
                {{ select.year ? select.year : 'N/A' }}
              </div>
            </div>
            <div class="details-col">
              <div class="detail-head">Country of Origin:</div>
              <div class="detail-value">
                {{ select.countryOfOrigin ? select.countryOfOrigin : 'N/A' }}
              </div>
            </div>
          </div>

          <div class="details-row">
            <div class="details-col">
              <div class="detail-head">Close Focus:</div>
              <div class="detail-value">
                {{ select.closeFocus ? select.closeFocus : 'N/A' }}
              </div>
            </div>
            <div class="details-col"></div>
          </div>
        </div>
        <div class="details-bottom-row">
          <div class="details-bottom-left">
            <div class="details-row">
              <div class="details-col">
                <div class="detail-head">Flare Type:</div>
                <div class="detail-value tag">
                  {{ getLensPropOptionLabel('flareType', select?.flareType) || 'N/A' }}
                </div>
              </div>
            </div>
            <div class="details-row">
              <div class="details-col">
                <div class="detail-head">Flare Color:</div>
                <div class="detail-value tag">
                  {{ getLensPropOptionLabel('flareColor', select?.flareColor) || 'N/A' }}
                </div>
              </div>
            </div>
            <div class="details-row">
              <div class="details-col">
                <div class="detail-head">Flare Intensity:</div>
                <div class="detail-value tag">
                  {{ getLensPropOptionLabel('flareIntensity', select?.flareIntensity) || 'N/A' }}
                </div>
              </div>
            </div>
            <div class="details-row">
              <div class="details-col">
                <div class="detail-head">Lens Era:</div>
                <div class="detail-value tag">
                  {{ getLensPropOptionLabel('lensEra', select?.lensEra) || 'N/A' }}
                </div>
              </div>
            </div>
          </div>
          <div class="details-bottom-right">
            <div class="films-row" v-if="select.notableFilms?.length > 0">
              <div class="films-head">Notable Films:</div>
              <div class="films-data-box">
                <div
                  class="films-data detail-value"
                  v-for="film in select.notableFilms"
                  :key="film.link"
                >
                  <a :href="film.link" target="_blank"
                    >{{ film.name }} <img src="@/assets/img/link-icon.svg" alt=""
                  /></a>
                </div>
              </div>
            </div>
            <div class="films-row" v-if="select.note?.length > 0">
              <div class="films-head">Note:</div>
              <div class="films-data-box">
                <div class="films-data detail-value" v-for="note in select.note" :key="note.title">
                  <a :href="note.description" target="_blank"
                    >{{ note.title }} <img src="@/assets/img/link-icon.svg" alt=""
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="select-pdf-table">
      <table cellpadding="0">
        <thead>
          <th>Focal Length</th>
          <th>Max Aperture</th>
          <th>Close Focus</th>
          <th>Weight</th>
          <th>Length</th>
          <th>Image Circle</th>
          <th>Front Diameter</th>
        </thead>
        <tbody>
          <td>
            {{ select.focalLength ? select.focalLength : 'N/A' }}
          </td>
          <td>
            {{ select.apertureRange ? select.apertureRange : 'N/A' }}
          </td>
          <td>
            {{ select.closeFocus ? select.closeFocus : 'N/A' }}
          </td>
          <td>
            {{ select.weight ? select.weight : 'N/A' }}
          </td>
          <td>
            {{ select.length ? select.length : 'N/A' }}
          </td>
          <td>
            {{ select.imageCircle ? select.imageCircle : 'N/A' }}
          </td>
          <td>
            {{ select.frontDiameter ? select.frontDiameter : 'N/A' }}
          </td>
        </tbody>
      </table>
    </div>
    <p class="pdf-copyrignt">
      © 2024 CINEFLARES. ALL RIGHTS RESERVED. TEST CONCEPTUALIZED AND PERFORMED BY MARKUS FORDERER,
      ASC
    </p>
  </section>
</template>

<script setup>
import client from '@/api/client'
import config from '@/config'
import { getLensPropOptionLabel } from '@/utils/string'
import { defineProps, onMounted, ref } from 'vue'
import { useUsersStore } from '@/stores/Users'

const userStore = useUsersStore()

const props = defineProps(['select'])
const baseImgUrl = ref(null)
const iconBase64 = ref(null)

const convertToBase64 = async url => {
  try {
    const response = await client.get(`${config.apiBaseUrl}/image/base64?url=${url}`)

    return response.data.base64
  } catch (err) {
    console.log(err)
  }
}

onMounted(async () => {
  baseImgUrl.value = await convertToBase64(props.select.sceneImageUrl || props.select.flareImage)
  iconBase64.value = await convertToBase64(props.select.icon)
})
</script>

<style scoped>
html {
  background: red;
}

.films-row {
  opacity: 1;
  color: black;
}

.details-col {
  opacity: 1;
}

.detail-value.tag {
  color: black;
}

.detail-value {
  color: black;
}

.details-pill {
  margin-bottom: 0;
  border-color: gray;
}

@media screen and (max-width: 1024px) {
  .details-bottom-row {
    flex-direction: row;
  }

  .details-row {
    flex-direction: row;
  }

  .details-bottom-row .detail-head {
    flex-basis: 40%;
  }

  .details-bottom-right {
    align-self: flex-end;
  }
}
</style>
